import Section from "./Section";
import Button from "./common/Button";
function BackgroundImageBox(props) {
  if(!props.data) return(<></>);
  const lang = props.lang;
  
  if(!props.data || !props.data.headline) return (<></>);
  return (
    <Section className="tw-p-5 tw-pb-0 tw-max-w-screen-lg tw-m-auto md:tw-py-5 group-fitness-bg">
      <div 
        className="bgimage tw-h-72 lg:tw-h-56 tw-rounded-lg lg:tw-rounded-2xl tw-bg-gray-medium tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-center tw-bg-cover tw-bg-no-repeat tw-pt-0 tw-px-6 lg:tw-mt-2"
        style={{
          backgroundImage: 'url("'+props.data.background+'")',
        }}
      >
        <h2 className="tw-relative tw-bottom-[1em] tw-mt-20 tw-tracking-tight tw-text-white tw-font-condensed tw-italic tw-text-3xl tw-uppercase tw-leading-3 tw-mt-4 xmd:tw-leading-3">
          {props.data.headline}
        </h2>
        <Button
          className="tw-mt-0 active:tw-border-transparent tw-w-full lg:tw-w-auto"
          color="white"
          size="small"
          title={props.data.button['text_'+lang]}
          href={props.data.button['url_'+lang]}
          />
      </div>
    </Section>
  );
}

export default BackgroundImageBox;
